import { create as _create } from "zustand";
import type { StateCreator } from "zustand";

export const create = (<T extends unknown>() => {
  return (stateCreator: StateCreator<T>) => {
    const store = _create(stateCreator);
    const initialState = store.getInitialState();

    storeResetFns.add(() => {
      store.setState(initialState, true);
    });
    return store;
  };
}) as typeof _create;
const storeResetFns = new Set<() => void>();

/**
 * Register a reset for session state outside a store, such as a module-level cache. Stores
 * register themselves via `create` above; anything else survives logout without this.
 */
export const registerResetFn = (resetFn: () => void) => {
  storeResetFns.add(resetFn);
};

export const resetAllStores = () => {
  storeResetFns.forEach((resetFn) => {
    resetFn();
  });
};
